<template>
  <div>
    <div
      class="d-flex align-center message-container"
      :class="`${signal} ${signal === 'mine' ? 'flex-row-reverse' : ''} justify-start`"
    >
      <small
        v-if="creationTime"
        class="text--secondary"
      >
        {{ formatDate(creationTime) }}
      </small>
      <v-card
        :color="signal === 'mine' ? 'primary' : 'light'"
        elevation="2"
        class="message px-3 py-1 mx-2 my-2"
        :dark="signal === 'mine'"
        style="border-radius: 10px"
      >
        <p
          v-if="signal === 'their' && username"
          class="from"
          v-html="username"
        ></p>
        <span v-html="message"></span>
      </v-card>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import fileUpload from '@/plugins/FileUpload'
import ocularMoment from '@/plugins/OcularMoment'

export default {
  props: {
    creationTime: {
      default: null
    },
    signal: {
      default: null
    },
    username: {
      default: null
    },
    message: {
      default: null
    }
  },
  methods: {
    formatDate (date) {
      return ocularMoment.formatDate(date, 'HH:mm', this.$store.state.locale)
    }
  },
  mounted () {
    this.$nextTick(() => {
      fileUpload.chatFileLinkGenerator(this.$el);
    })
  }
}
</script>
